import {Injectable} from '@angular/core';
import {BookingStatus, TimingStatus} from '../api/api';

@Injectable({
  providedIn: 'root'
})
export class BookingStatusService {

  constructor() {
  }

  private static extractReasons(bookingStatusField: any): Map<BookingStatus, number> {
    const reasons: Map<BookingStatus, number> = new Map();
    bookingStatusField = JSON.parse(JSON.stringify(bookingStatusField));
    for (const bookingStatus in BookingStatus) {
      if (bookingStatusField && bookingStatusField.hasOwnProperty(bookingStatus)) {
        reasons.set(BookingStatus[bookingStatus], bookingStatusField[bookingStatus]);
      }
    }

    return reasons;
  }

  getReasons(bookingStatusObject: any, timingStatusCounted: TimingStatus[] = null): Map<BookingStatus, number> {
    bookingStatusObject = JSON.parse(JSON.stringify(bookingStatusObject));
    if (timingStatusCounted == null) {
      timingStatusCounted = [];
      for (const timingStatus in TimingStatus) {
        if (timingStatus) {
          timingStatusCounted.push(TimingStatus[timingStatus]);
        }
      }
    }
    let hasTimingStatus = false;
    for (const timingStatus in TimingStatus) {
      if (bookingStatusObject && bookingStatusObject.hasOwnProperty(TimingStatus[timingStatus])) {
        hasTimingStatus = true;
        break;
      }
    }

    if (hasTimingStatus) {
      const reasons: Map<BookingStatus, number> = new Map();
      for (const timingStatus of timingStatusCounted) {
        if (bookingStatusObject.hasOwnProperty(timingStatus)) {
          const reasonsInTimingStatus = BookingStatusService.extractReasons(bookingStatusObject[timingStatus]);
          for (const entry of reasonsInTimingStatus.entries()) {
            const bookingStatus: BookingStatus = entry[0];
            if (!reasons.has(bookingStatus)) {
              reasons.set(bookingStatus, 0);
            }
            reasons.set(bookingStatus, reasons.get(bookingStatus) + entry[1]);
          }
        }
      }
      return reasons;
    } else {
      return BookingStatusService.extractReasons(bookingStatusObject);
    }

  }

}
